<template>
  <el-container>
    <el-aside width="160px" style="background: #545c64">
      <Menu @handleViewData="handleViewData" />
    </el-aside>
    <el-container>
      <el-header style="height: 64px; padding: 0px">
        <TitleBar />
      </el-header>
      <el-main>
        <div class="home" v-if="pathName === 'home'">
          <el-row
            v-if="yesterdayResult"
            style="text-align: center;padding-bottom: 20px;"
          >
            <el-col :span="6">
              <div class="">
                <div class="title2">昨日总订单量</div>
                <div class="yday">{{ yesterday_chartData1.rows[0].a }}</div>

                <!-- <ve-gauge
                  height="350px"
                  :data="yesterday_chartData1"
                  :settings="yesterday_chartSettings1"
                ></ve-gauge> -->
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <div class="title2">昨日总营业额</div>
                <div class="yday">{{ yesterday_chartData2.rows[0].a }}</div>

                <!-- <ve-gauge
                  height="350px"
                  :data="yesterday_chartData2"
                  :settings="yesterday_chartSettings2"
                ></ve-gauge> -->
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <div class="title2">昨日已付费订单量</div>
                <div class="yday">{{ yesterday_chartData3.rows[0].a }}</div>

                <!-- <ve-gauge
                  height="350px"
                  :data="yesterday_chartData3"
                  :settings="yesterday_chartSettings3"
                ></ve-gauge> -->
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <div class="title2">昨日已取消订单量</div>
                <div class="yday">{{ yesterday_chartData4.rows[0].a }}</div>

                <!-- <ve-gauge
                  height="350px"
                  :data="yesterday_chartData4"
                  :settings="yesterday_chartSettings4"
                ></ve-gauge> -->
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="todayResult" style="text-align: center;">
            <el-col :span="6">
              <div class="">
                <div class="title">今日总订单量</div>
                <ve-gauge
                  :data="chartData1"
                  :settings="chartSettings1"
                ></ve-gauge>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <div class="title">今日总营业额</div>
                <ve-gauge
                  :data="chartData2"
                  :settings="chartSettings2"
                ></ve-gauge>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <div class="title">今日已付费订单量</div>
                <ve-gauge
                  :data="chartData3"
                  :settings="chartSettings3"
                ></ve-gauge>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <div class="title">今日已取消订单量</div>
                <ve-gauge
                  :data="chartData4"
                  :settings="chartSettings4"
                ></ve-gauge>
              </div>
            </el-col>
          </el-row>

          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>机器状态图</span>
            </div>
            <div class="text item">
              <div
                v-for="item in machineStatusCountList"
                :key="item.machineStatus"
                :class="['panel-item', 'panel' + item.machineStatus]"
                @click="redirect(item)"
              >
                <div class="machineStatus">
                  {{ item.machineStatusZH }}
                </div>
                <div class="position-absolute">数量： {{ item.count }}</div>
              </div>
              <div
                class="panel-item panel-disable"
                @click="redirectDisabledMachineCount()"
              >
                <div class="machineStatus">禁用</div>
                <div class="position-absolute">
                  数量： {{ this.disabledMachineCount }}
                </div>
              </div>
            </div>

            <!-- <el-collapse>
              <el-collapse-item
                :title="x.name + '--【' + getSubPanel(x.status).length + '台】'"
                :name="x.status"
                :key="index"
                v-for="(x, index) in menuList"
              >
                <div class="text item">
                  <div
                    :class="['panel-item', 'panel' + item.machineStatus]"
                    v-for="(item, index) of getSubPanel(x.status)"
                    :key="index"
                    @click="redirect(item)"
                  >
                    <div class="machineStatus">
                      {{ item.machineid }}
                    </div>
                    <div class="machineStatus">
                      {{ item.machineName }}
                    </div>
                    <div class="position-absolute">
                      状态：{{ item.machineStatus | filterStatue }}
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse> -->
          </el-card>

          <el-card class="box-card">
            <div class="text item">
              <ve-ring :data="chartDataMachine" :extend="chartExtend"></ve-ring>
            </div>
          </el-card>
        </div>
        <router-view />
      </el-main>
      <el-footer>
        <CopyRight :className="'footer-relative'" />
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import TitleBar from "@/components/layout/titleBar";
import ENUM from "../plugins/enum";
import moment from "moment";

import { initBasicData } from "../main.js";

// import ICountUp from "vue-countup-v2";
export default {
  name: "home",
  data() {
    return {
      chartDataMachine: {
        columns: ["状态", "台数"],
        rows: []
      },

      menuList: [
        { status: -1, name: "离线" },
        { status: 0, name: "门未关" },
        //{ status: 2, name: "待机" },
        { status: 8, name: "启动" },
        { status: 16, name: "运行中" },
        { status: 32, name: "运行结束" },
        { status: 64, name: "故障" },
        { status: 128, name: "菜单模式" }
      ],

      chartExtend: {},
      disabledMachineCount: 0,
      panelList: [],
      machineStatusCountList: {},
      todayResult: null,
      yesterdayResult: null,
      chartData1: {
        columns: ["type", "a"],
        rows: [{ type: "今日总订单量", a: 0 }]
      },
      chartData2: {
        columns: ["type", "a"],
        rows: [{ type: "今日总营业额", a: 0 }]
      },
      chartData3: {
        columns: ["type", "a"],
        rows: [{ type: "今日已付费订单量", a: 0 }]
      },
      chartData4: {
        columns: ["type", "a"],
        rows: [{ type: "今日已取消订单量", a: 0 }]
      },
      chartSettings1: {
        dataName: {
          今日总订单量: "订单量"
        },
        seriesMap: {
          今日总订单量: {
            max: 15000
          }
        }
      },
      chartSettings2: {
        dataName: {
          今日总营业额: "金额（元）"
        },
        seriesMap: {
          今日总营业额: {
            max: 100000
          }
        }
      },
      chartSettings3: {
        dataName: {
          今日已付费订单量: "订单量"
        },
        seriesMap: {
          今日已付费订单量: {
            max: 15000
          }
        }
      },
      chartSettings4: {
        dataName: {
          今日已取消订单量: "订单量"
        },
        seriesMap: {
          今日已取消订单量: {
            max: 1000
          }
        }
      },
      yesterday_chartData1: {
        columns: ["type", "a"],
        rows: [{ type: "昨日总订单量", a: 0 }]
      },
      yesterday_chartData2: {
        columns: ["type", "a"],
        rows: [{ type: "昨日总营业额", a: 0 }]
      },
      yesterday_chartData3: {
        columns: ["type", "a"],
        rows: [{ type: "昨日已付费订单量", a: 0 }]
      },
      yesterday_chartData4: {
        columns: ["type", "a"],
        rows: [{ type: "昨日已取消订单量", a: 0 }]
      },
      yesterday_chartSettings1: {
        dataName: {
          昨日总订单量: "订单量"
        },
        seriesMap: {
          昨日总订单量: {
            max: 15000
          }
        }
      },
      yesterday_chartSettings2: {
        dataName: {
          昨日总营业额: "金额（元）"
        },
        seriesMap: {
          昨日总营业额: {
            max: 100000
          }
        }
      },
      yesterday_chartSettings3: {
        dataName: {
          昨日已付费订单量: "订单量"
        },
        seriesMap: {
          昨日已付费订单量: {
            max: 15000
          }
        }
      },
      yesterday_chartSettings4: {
        dataName: {
          昨日已取消订单量: "订单量"
        },
        seriesMap: {
          昨日已取消订单量: {
            max: 1000
          }
        }
      }
    };
  },
  components: {
    TitleBar
    // ICountUp
  },
  computed: {
    pathName() {
      return this.$route.name;
    }
  },
  watch: {
    pathName(newVal, oldVal) {
      if (newVal === "home" && newVal !== oldVal) {
        this.showMeTheMoney();
      }
    }
  },
  filters: {
    filterStatue(value) {
      let type = ENUM.MACHINE_STATUS_ENUM.find(ele => {
        return ele.value === value;
      });
      if (type) {
        return type.label;
      } else {
        return "未知";
      }
    }
  },
  methods: {
    redirect(e) {
      console.log(e);
      this.$router.push({
        name: "machine",
        query: {
          machineStatus: e.machineStatus
        }
      });
    },

    redirectDisabledMachineCount() {
      this.$router.push({
        name: "machine",
        query: {
          machineEnable: 0
        }
      });
    },

    getSubPanel(status) {
      //console.log("status:" + status);
      let sub = this.panelList.filter(ele => ele.machineStatus === status);
      //console.log(sub);
      return sub;
    },

    // getMachineByStatus() {
    //   this.$axios(this.$urlMapping["根据状态查询机器"], {
    //     data: {
    //       // Offline(-1, "离线"),
    //       // DoorOpened(0, "门未关"),
    //       // Ready(2, "待机"),
    //       // Start(8, "启动"),
    //       // Run(16, "运行中"),
    //       // End(32, "运行结束"),
    //       // Error(64, "故障"),
    //       // Manual(128, "菜单模式");
    //       statusList: [-1, 0, 8, 16, 32, 64, 128]
    //     }
    //   }).then(res => {
    //     console.log(res);
    //     this.panelList = res;
    //   });
    // },
    getMachineStatusStatistic() {
      this.$axios(this.$urlMapping["查询机器状态统计值"], {
        data: {}
      }).then(result => {
        let list = result;
        this.machineStatusCountList = result; //用于方块显示
        this.chartDataMachine.rows = [];
        list.forEach((ele, index) => {
          this.chartDataMachine.rows.push({
            状态: ele.machineStatusZH + " " + ele.count + "台",
            台数: ele.count
          });
          this.chartExtend[
            `series.0.data.${index}.itemStyle.color`
          ] = this.translateColor(ele.machineStatus);
        });
      });
    },

    async getDisabledMachineCount() {
      let res = await this.$axios(this.$urlMapping["查询禁用机器数"], {
        data: {}
      });
      this.disabledMachineCount = res;
      // console.log("this.disabledMachineCount=" + this.disabledMachineCount);
    },

    getSimpleOrderStatistic() {
      this.$axios(this.$urlMapping["查询简单订单统计"], {
        data: {
          orderDateFrom: this.$ToDateTimeString(
            moment()
              .utcOffset(480)
              .startOf("day")
          ),
          orderDateTo: this.$ToDateTimeString(
            moment()
              .add(1, "days")
              .utcOffset(480)
              .startOf("day")
          )
        }
      }).then(result => {
        this.todayResult = result;
        this.chartData1.rows[0].a = this.todayResult.totalOrderCount;
        this.chartData2.rows[0].a = this.todayResult.totalOrderAmount;
        this.chartData3.rows[0].a = this.todayResult.totalPaidCount;
        this.chartData4.rows[0].a = this.todayResult.totalCancelCount;
      });
    },

    getSimpleOrderStatistic_yesterday() {
      this.$axios(this.$urlMapping["查询简单订单统计"], {
        data: {
          orderDateFrom: this.$ToDateTimeString(
            moment()
              .add(-1, "days")
              .utcOffset(480)
              .startOf("day")
          ),
          orderDateTo: this.$ToDateTimeString(
            moment()
              .utcOffset(480)
              .startOf("day")
          )
        }
      }).then(result => {
        this.yesterdayResult = result;
        this.yesterday_chartData1.rows[0].a = this.yesterdayResult.totalOrderCount;
        this.yesterday_chartData2.rows[0].a = this.yesterdayResult.totalOrderAmount;
        this.yesterday_chartData3.rows[0].a = this.yesterdayResult.totalPaidCount;
        this.yesterday_chartData4.rows[0].a = this.yesterdayResult.totalCancelCount;
      });
    },

    translateColor(type) {
      switch (type) {
        case -1:
          return "lightgray";
        case 0:
          return "#909399";
        case 2:
          return "#e6a23c";
        case 8:
          return "#67c23a";
        case 16:
          return "#409eff";
        case 32:
          return "violet";
        case 64:
          return "#f56c6c";
        case 128:
          return "#000";
        default:
          return "";
      }
    },
    // getAllMachineModelInfoList() {
    //   this.$axios(this.$urlMapping["查询机器联动"], {
    //     data: {}
    //   }).then(result => {
    //     this.$store.commit("setAllMachineModelInfoList", result);
    //   });
    // },
    handleViewData() {
      this.showMeTheMoney();
    },
    showMeTheMoney() {
      //this.getMachineByStatus();
      this.getMachineStatusStatistic();
      this.getSimpleOrderStatistic();
      this.getSimpleOrderStatistic_yesterday();
      this.getDisabledMachineCount();
      //this.getAllMachineModelInfoList();
    }
  },
  mounted() {
    this.showMeTheMoney();
    console.log("home mounted", this.$getToken());
    initBasicData();
  }
};
</script>

<style lang="less" scoped>
.home {
  font-size: 20px;
  color: #409eff;
}

.title2 {
  color: #409eff;
}
.yday {
  margin: 20px 0;
  color: #333;
}

/deep/ .el-aside {
  overflow: hidden;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
  overflow: hidden;
}

.clearfix {
  font-size: 18px;
  color: #333;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.true-jkjkdf {
  overflow: hidden;
  padding: 0.5rem;
}

.panel-item {
  width: 160px;
  height: 90px;
  border: 2px solid;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  float: left;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
  border-radius: 8px;
  transition: all 0.25s;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}

.panel-1 {
  border-color: lightgray;
}

.panel0 {
  border-color: #909399;
}

.panel2 {
  border-color: #e6a23c;
}

.panel8 {
  border-color: #67c23a;
}

.panel16 {
  border-color: #409eff;
}

.panel32 {
  border-color: violet;
}

.panel64 {
  border-color: #f56c6c;
}

.panel128 {
  border-color: #000;
}
.panel-disable {
  border-color: #fdd835;
}

.machineStatus {
  font-size: 18px;
  font-weight: normal;
  word-break: break-word;
}

.position-absolute {
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-size: 14px;
  font-weight: normal;
}
</style>
